export default import.meta.ROLLDOWN_FILE_URL_ORgOs2A6mYI8zc5N1U1L8w